const UserAvatarIcon = ({ className }: { className?: string }) => (
  <svg
    width="286"
    height="286"
    viewBox="0 0 286 286"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="143" cy="143" r="143" fill="#797979" />
    <path
      d="M142.154 0C104.302 0.223982 68.0828 15.4467 41.436 42.3313C14.7892 69.216 -0.111364 105.569 0.000626742 143.422C0.112617 181.275 15.228 217.539 42.0334 244.265C68.8389 270.992 105.147 286 143 286C180.853 286 217.161 270.992 243.967 244.265C270.772 217.539 285.887 181.275 285.999 143.422C286.111 105.569 271.211 69.216 244.564 42.3313C217.917 15.4467 181.698 0.223982 143.846 0H142.154ZM142.154 72.7699C159.135 72.9933 175.338 79.9245 187.227 92.0507C199.116 104.177 205.726 120.514 205.614 137.496C205.502 154.478 198.678 170.726 186.63 182.695C174.583 194.663 158.29 201.381 141.308 201.381C124.326 201.381 108.033 194.663 95.9851 182.695C83.9375 170.726 77.1131 154.478 77.0014 137.496C76.8897 120.514 83.4996 104.177 95.3888 92.0507C107.278 79.9245 123.481 72.9933 140.462 72.7699H142.154ZM47.3846 242.425C62.6154 222.681 81.5128 212.81 104.077 212.81H181.923C204.487 212.81 223.385 222.681 238.615 242.425C212.821 266.948 178.591 280.623 143 280.623C107.409 280.623 73.1787 266.948 47.3846 242.425Z"
      fill="#DDDDDD"
    />
  </svg>
);

export default UserAvatarIcon;
